<div fxLayout="column" class="toolip-card">
  <div class="bg-app-bar border-b px-3 py-2" fxLayout="row" fxLayoutAlign="space-between center">
    <h4 class="m-0 primary"><b>{{data.heading}}</b></h4>
  </div>
  <div class="py-2 px-3 bg-primary" fxLayout="row">
   <p class="leading-relaxed text-white break-word">
  <span [innerHTML]="isShowReadmore ? data.text : (data.text | slice:0:400)"></span>
</p>
  </div>
  <div class="py-2 px-3 bg-primary" fxLayout="row" fxLayoutAlign="space-between center" *ngIf="!isHideButton">
    <button class="bg-white text-primary" type="button" mat-raised-button 
      (click)="toggleReadMore(data.text,data.heading)" 
      *ngIf="!isShowReadmore && data.text.length > 400">
      Readmore
    </button>

    <button class="bg-white text-primary" type="button" mat-raised-button 
      (click)="close()">Got it
    </button>
  </div>
</div>
